import { useEffect, useState } from 'react';

type KeyboardHeightState = {
  keyboardHeight: number;
  fullHeight: number;
  availableHeight: number;
  isVisible: boolean;
};

export default function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState<KeyboardHeightState>({
    keyboardHeight: 0,
    fullHeight: 0,
    availableHeight: 0,
    isVisible: false,
  });

  useEffect(() => {
    const handleKeyboardHeightChange = () => {
      if (!window.visualViewport) return;

      const fullHeight = document.documentElement.clientHeight;
      const availableHeight = window.visualViewport.height;
      const isVisible = fullHeight > availableHeight;

      setKeyboardHeight({
        keyboardHeight: Math.max(0, fullHeight - window.visualViewport.height),
        fullHeight,
        availableHeight,
        isVisible,
      });
    };

    // Listen for viewport changes
    window.visualViewport?.addEventListener('resize', handleKeyboardHeightChange);
    window.visualViewport?.addEventListener('scroll', handleKeyboardHeightChange);

    // Initial check
    handleKeyboardHeightChange();

    return () => {
      window.visualViewport?.removeEventListener('resize', handleKeyboardHeightChange);
      window.visualViewport?.removeEventListener('scroll', handleKeyboardHeightChange);
    };
  }, []);

  return keyboardHeight;
}
